import PropTypes from "prop-types"
import React, { useEffect } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "./assets/css/calendarStyles.css"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "react-grid-layout/css/styles.css"
import "react-resizable/css/styles.css"

import { Routes, Route } from "react-router-dom"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./App.css"
import AccessDenied from "routes/AccessDenied"
import secureLocalStorage from "react-secure-storage"
import { AppContext } from "AppContext"

const App = () => {
  const Layout = HorizontalLayout

  return (
    <React.Fragment>
      <AppContext>
        <Routes>
          <Route path="*" element={<AccessDenied />} />
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Routes>
      </AppContext>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
